var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({key:Math.random(),tag:"component",on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }